import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export interface PageHeaderProps {
	title: string;
	subtitle?: ReactNode;
	actions?: ReactNode;
	meta?: ReactNode;
	className?: string;
}

/**
 * Единый заголовок страницы. Используется на всех восьми экранах рабочего места,
 * чтобы исключить визуальные разрывы между типографикой `pages/*\/index.tsx`.
 *
 * - title: 22px / 600 / text-slate-900
 * - subtitle: 13px / text-slate-500, mt-1
 * - actions: слот справа (flex gap-2)
 * - meta: дополнительная строка под заголовком (бейджи, period selector и т.д.)
 */
export function PageHeader({ title, subtitle, actions, meta, className }: PageHeaderProps) {
	return (
		<header className={cn("mb-6 flex items-start justify-between gap-4", className)}>
			<div className="min-w-0 flex-1">
				<h1 className="text-[22px] font-semibold leading-tight text-slate-900">{title}</h1>
				{subtitle ? <p className="mt-1 text-[13px] text-slate-500">{subtitle}</p> : null}
				{meta ? <div className="mt-2 flex flex-wrap items-center gap-2">{meta}</div> : null}
			</div>
			{actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
		</header>
	);
}
